import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';


import { ShFacet, ShSelectedFacetValue } from '../facet/entities/facet.entity';
import { ShFacetComponent } from '../facet/facet.component';
import { ShIconModule } from '../icon/icon.module';

@Component({
    standalone: true,
    selector: 'sh-facet-list',
    templateUrl: './facet-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ShIconModule, ShFacetComponent]
})
export class ShFacetListComponent {
    @Input() facets!: ShFacet[];
    @Input() showMoreMsg = 'Show more';
    @Input() blockShowMore = false;

    @Output() facetSelected: EventEmitter<ShSelectedFacetValue> = new EventEmitter<ShSelectedFacetValue>();
    @Output() facetsChange: EventEmitter<ShFacet[]> = new EventEmitter<ShFacet[]>();
    @Output() loadMore: EventEmitter<ShFacet> = new EventEmitter<ShFacet>();

    public onValueSelected(selectedFacetValue: ShSelectedFacetValue): void {
        this.facetSelected.emit(selectedFacetValue);
    }

    public onSelectionChange(changedFacet: ShFacet): void {
        const newState: ShFacet[] = this.facets.map(facet => {
            if (this.isSameFacet(changedFacet, facet)) {
                return changedFacet;
            }
            return facet;
        });
        this.facetsChange.emit(newState);
    }

    private isSameFacet(facet1: ShFacet, facet2: ShFacet): boolean {
        return facet1.key === facet2.key;
    }

    public onLoadMore(facet: ShFacet): void {
        this.loadMore.emit(facet);
    }
}
